import React from "react";

export const FacetSetItemUI = React.memo<{ title: string; items: string[]; separator?: string; }>(({
  title,
  items,
  separator = ", ",
}) => (
  <span>{title}: {items.join(separator)}</span>
));
